import React, { useEffect, useState, useRef } from 'react';
import ReactExport from "react-export-excel";
const { ExcelFile, ExcelFile: { ExcelSheet, ExcelColumn } } = ReactExport;

export default function ExcelFileTemplate({ dataSet }) {
  return (
    <ExportExcelFile dataSet={dataSet}>
      <button className="btn btn-sm d-inline-flex btn-green">
        Formato Excel
      </button>
    </ExportExcelFile>
  );
};

export function ExportExcelFile({ dataSet, fetchDataExcel, children }) {
  const { fileResultName, sheetName = "Hoja 1", columns } = dataSet;
  const [clickedFromChildren, setClickedFromChildren] = useState(false);
  const btnExcelRef = useRef();

  useEffect(() => {
    if (columns && clickedFromChildren) {
      btnExcelRef.current.click();
      setClickedFromChildren(false);
    }
  }, [columns, clickedFromChildren]);

  const handleChildButtonClick = () => {
    if (columns) {
      btnExcelRef.current.click();
    } else {
      setClickedFromChildren(true);
      fetchDataExcel();
    }
  };

  return (
    <>
      {columns &&
        <ExcelFile
          filename={fileResultName}
          element={<button type="button" className="d-none" ref={btnExcelRef}></button>}
        >
          <ExcelSheet data={columns} name={sheetName}>
            {Object.keys(columns[0]).map((name, index) => (
              <ExcelColumn key={index} label={name} value={name} />
            ))}
          </ExcelSheet>
        </ExcelFile>
      }
      {React.cloneElement(children, { onClick: () => handleChildButtonClick() })}
    </>
  )
};